import React, { useEffect } from "react";

const Confetti = () => {
  const TWO_PI = Math.PI * 2;
  const HALF_PI = Math.PI * 0.5;

  // canvas settings
  const viewWidth = 512;
  const viewHeight = 350;
  let drawingCanvas;
  let ctx;
  const timeStep = 1 / 60;

  let Point = function (x, y) {
    this.x = x || 0;
    this.y = y || 0;
  };

  let Particle = function (p0, p1, p2, p3) {
    this.p0 = p0;
    this.p1 = p1;
    this.p2 = p2;
    this.p3 = p3;

    this.time = 0;
    this.duration = 3 + Math.random() * 2;
    this.color = '#' + Math.floor((Math.random() * 0xffffff)).toString(16);

    this.w = 8;
    this.h = 6;

    this.complete = false;
  };

  Particle.prototype = {
    update: function () {
      this.time = Math.min(this.duration, this.time + timeStep);

      var f = Ease.outCubic(this.time, 0, 1, this.duration);
      var p = cubeBezier(this.p0, this.p1, this.p2, this.p3, f);

      var dx = p.x - this.x;
      var dy = p.y - this.y;

      this.r = Math.atan2(dy, dx) + HALF_PI;
      this.sy = Math.sin(Math.PI * f * 10);
      this.x = p.x;
      this.y = p.y;

      this.complete = this.time === this.duration;
    },
    draw: function () {
      ctx.save();
      ctx.translate(this.x, this.y);
      ctx.rotate(this.r);
      ctx.scale(1, this.sy);

      ctx.fillStyle = this.color;
      ctx.fillRect(-this.w * 0.5, -this.h * 0.5, this.w, this.h);

      ctx.restore();
    },
  };

  const particles = [];
  let phase = 0;

  const initDrawingCanvas = () => {
    drawingCanvas = document.getElementById("drawing_canvasE");
    drawingCanvas.width = viewWidth;
    drawingCanvas.height = viewHeight;
    ctx = drawingCanvas.getContext('2d');

    createParticles();
  };

  const createParticles = () => {
    for (let i = 0; i < 328; i++) {
      const p0 = new Point(viewWidth * 0.5, viewHeight * 0.5);
      const p1 = new Point(Math.random() * viewWidth, Math.random() * viewHeight);
      const p2 = new Point(Math.random() * viewWidth, Math.random() * viewHeight);
      const p3 = new Point(Math.random() * viewWidth, viewHeight + 64);

      particles.push(new Particle(p0, p1, p2, p3));
    }
  };

  const update = () => {
    switch (phase) {
      case 0:
        particles.forEach(function (p) {
          p.update();
        });
        break;
      default:
        break;
    }
  };

  const draw = () => {
    ctx.clearRect(0, 0, viewWidth, viewHeight);

    switch (phase) {
      case 0:
        particles.forEach(function (p) {
          p.draw();
        });
        break;
      default:
        break;
    }
  };

  const loop = () => {
    update();
    draw();

    if (phase === 0 && checkParticlesComplete()) {
      // reset
      phase = 0;
      particles.length = 0;
      createParticles();
    }

    requestAnimationFrame(loop);
  };

  const checkParticlesComplete = () => {
    for (let i = 0; i < particles.length; i++) {
      if (particles[i].complete === false) return false;
    }
    return true;
  };

  // math and stuff
  const Ease = {
    outCubic: function (t, b, c, d) {
      t /= d;
      t--;
      return c * (t * t * t + 1) + b;
    },
  };

  const cubeBezier = (p0, c0, c1, p1, t) => {
    const p = new Point();
    const nt = 1 - t;

    p.x =
      nt * nt * nt * p0.x +
      3 * nt * nt * t * c0.x +
      3 * nt * t * t * c1.x +
      t * t * t * p1.x;
    p.y =
      nt * nt * nt * p0.y +
      3 * nt * nt * t * c0.y +
      3 * nt * t * t * c1.y +
      t * t * t * p1.y;

    return p;
  };

  useEffect(() => {
    const initAnimation = () => {
      initDrawingCanvas();
      requestAnimationFrame(loop);
    };

    // Start the animation after a delay of 4 seconds
    const delay = 4000;
    const timeoutId = setTimeout(initAnimation, delay);

    return () => {
      clearTimeout(timeoutId); // Clear the timeout if the component unmounts before the animation starts
    };
  }, []);

  return (
    <div className="confetti-animation">
      <canvas id="drawing_canvasE"></canvas>
    </div>
  );
};

export default Confetti;
